module.exports = __webpack_public_path__ + "img/junta_de_saneamiento_fram.a42c66fe.png";